// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollButton_scroll__3fO9h","line":"ScrollButton_line__1CsX5","arrowsDown":"ScrollButton_arrowsDown__2WVhd","arrowsDownSmall":"ScrollButton_arrowsDownSmall__2T-WF"};